// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .form-group-title {
  font-weight: bold;
  margin-top: 30px;
}
:host a {
  font-size: 14px;
  font-weight: normal;
}`, "",{"version":3,"sources":["webpack://./src/app/U2000_sharedmodules/U2000_security/U2000_verifyidentity/U2000_securityquestion/U2000_securityquestion-form/U2000_securityquestion-form.component.scss"],"names":[],"mappings":"AAKI;EACI,iBAAA;EACA,gBAAA;AAJR;AAMI;EACI,eAAA;EACA,mBAAA;AAJR","sourcesContent":["\n@import \"../../../../../U2000_style/U2000_style-mixins\";\n@import \"../../../../../U2000_style/U2000_style-variables\";\n\n:host {\n    .form-group-title {\n        font-weight: bold;\n        margin-top: 30px;\n    }\n    a {\n        font-size: 14px;\n        font-weight: normal;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
